import { com } from '@eidu/web'
import EntityWithLabelAndRelated from '../domain/entity/EntityWithLabelAndRelated'
import Link from '../domain/entity/Link'
import { formatRuntimeRef, parseRuntimeRef, RuntimeRef } from './runtimeRef'
import assetRuntimeLinkKey = com.eidu.entity.assetRuntimeLinkKey

const getRuntimeLinkValue = (entity: EntityWithLabelAndRelated): string | undefined =>
  entity.entity.links.asJsReadonlyMapView().get(assetRuntimeLinkKey)

export const getRuntimeRefFromEntity = (entity: EntityWithLabelAndRelated): RuntimeRef | undefined =>
  parseRuntimeRef(getRuntimeLinkValue(entity))

export const getRuntimeIdFromEntity = (entity: EntityWithLabelAndRelated): string | undefined =>
  getRuntimeRefFromEntity(entity)?.entityId

export const getEntityLinkFromRuntimeRef = (ref: RuntimeRef | null): Link => ({
  key: assetRuntimeLinkKey,
  value: formatRuntimeRef(ref),
})
